import React, { useEffect, useState, Fragment } from "react";
import cmsApi from "../../../helpers/cmsApi";
import { Link } from 'react-router-dom';
import PVFAQs from './PVFAQs';
import ProgramNavbar from '../../PartnerwithPV/AuthorizedRetailerProgram/Programs/ProgramNavbar';

function PVAcquistionServices() {
    const [pvacquistionsdata, setpvacquistionsdata] = useState("");
    const [FAQs, setFAQs] = useState([]);

  useEffect(() => {
    const fetchdata = async () => {
      const response = await cmsApi.get("pvacquistionservices");
        setpvacquistionsdata(response.data.items[0].data.pvacquistionsdata.iv[0]);
        setFAQs(response.data.items[0].data.FrequentlyAskedQuestion.iv);
    };
    fetchdata();
  }, []);

  console.log("pvacquistionsdata", pvacquistionsdata);
  return (
    <React.Fragment>
 <div className="pv-partner-resources-header-background ">
          <img
            src={
              "https://cloud.squidex.io/api/assets/" +
              pvacquistionsdata.MainImage
            } alt=""
          />
          </div>
          <ProgramNavbar programName="" />
      <div className="container">
        
        {/*   Left column Contents  */}
        <div className="product-acquistions-container-left">
          <h1 className="product-acquistions-text-header pv-text-transform-none">
            {pvacquistionsdata.Title}
          </h1>
          <div className="product-acquistions-text-paragraph">
            {pvacquistionsdata.ParagraphText}
                  </div>
                  <Link to={pvacquistionsdata.BecomeRetailerButtonLink}>
                      <button className="pv btn btn-primary product-acquistions-buttonondiv" style={{ width: '-webkit-fill-available', textAlign:'center'}} type="button">
                          {pvacquistionsdata.BecomeRetailerButtonText}
                      </button>
                  </Link>
                  <div className="pv-our-partners-divider" /> {/*  DIVIDER*/}
                  <div className="product-solutions-extra-spacing" />
          <div className="home-page-text-header">
            {pvacquistionsdata.OurPartners}
          </div>
          <img
            src={
              "https://cloud.squidex.io/api/assets/" +
              pvacquistionsdata.PartnerLogos
            } alt=""
          />
          <div className="product-solutions-extra-spacing" />
          <div className="pv-our-partners-divider" /> {/*  DIVIDER*/}
          <div className="product-solutions-extra-spacing" />
          <div className="home-page-text-header">
            {pvacquistionsdata.SupportHead}
          </div>
          <div className="product-acquistions-text-paragraph">
            {pvacquistionsdata.SupportText}
          </div>
          <div className="product-acquistions-Subheader-link">
            <div className="product-acquistions-last-Image">
              <img
                src={
                  "https://cloud.squidex.io/api/assets/" +
                  pvacquistionsdata.SupportImg
                } alt=""
              />
            </div>
            <ul>
              <li>{pvacquistionsdata.SupportLink1}</li>
              <li>{pvacquistionsdata.SupportLink2}</li>
              <li>{pvacquistionsdata.SupportLink3}</li>
              <li>{pvacquistionsdata.SupportLink4}</li>
              <li>{pvacquistionsdata.SupportLink5}</li>
              <li>{pvacquistionsdata.SupportLink6}</li>
              <li>{pvacquistionsdata.SupportLink7}</li>
              <li>{pvacquistionsdata.SupportLink8}</li>
            </ul>
                  </div><div className="pv-our-partners-divider" />
        <PVFAQs FAQs={FAQs} />
        </div>
            {/*  Right column Testimonial image*/}
            <div className="product-acquistions-container-right">
                   <div className="product-acquistions-testimonial-text-header">
                    <p>Testimonials</p>
                  </div>
                  <div className="product-acquistions-testimonial-text">
                    <p>{pvacquistionsdata.TestimonialText} </p>
                    <br />
                    <i> {pvacquistionsdata.TestimonialAuthor}</i>
                    <br />
                    <i> {pvacquistionsdata.AuthorTitle}</i>
                  </div>
            </div>{/* container-right*/}
      </div> {/*  container*/}
    </React.Fragment>
  );
}
export default PVAcquistionServices;
